// app optional di brian



(() => {
  if (window.__lbOptionalInit) return;
  window.__lbOptionalInit = true;

  function findWrap(form) {
    return form.closest('section, .shopify-section, .product, main, body')
      ?.querySelector('[data-lb-optional]');
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    const wrap = findWrap(form);
    if (!wrap) return;

    // blocca subito submit tema
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const addonCheckboxes = Array.from(wrap.querySelectorAll('.lb-optional__checkbox'));

    const fd = new FormData(form);
    const mainVariantId = Number(fd.get('id'));
    if (!mainVariantId) return;

    const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10));

    const selectedAddons = addonCheckboxes
      .filter(cb => cb.checked)
      .map(cb => {
        const row = cb.closest('.lb-optional__item');
        const mode = cb.dataset.qtyMode || 'one';

        let addonQty = 1;
        if (mode === 'custom') {
          const qtyInput = row ? row.querySelector('.lb-optional__qty') : null;
          addonQty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
        }

        return { id: Number(cb.value), quantity: addonQty };
      })
      .filter(x => x.id);

    const items = [
      { id: mainVariantId, quantity: qty },
      ...selectedAddons.map(a => ({
        id: a.id,
        quantity: a.quantity,
        parent_id: mainVariantId
      }))
    ];

    let root = window.Shopify?.routes?.root || '/';
    if (!root.endsWith('/')) root += '/';

    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
    
    if (!res.ok) {
      console.error('cart/add.js error:', await res.text());
      return;
    }

    addonCheckboxes.forEach(cb => (cb.checked = false));

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    }));
  
    
    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('#CartDrawer .drawer__close-btn.static');
      if (!closeBtn) return;
      
      const drawer = document.getElementById('CartDrawer');
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('inert', '');
      drawer.removeAttribute('open', '');
      drawer.removeAttribute('active', '');
      document.querySelector('body').classList.remove('modal-show');
      drawer.querySelector('.fixed-overlay').setAttribute('aria-expanded', 'false')

    });
  
  }, true);
})();
